import { Province } from "@vw-marketing/vw-ca-types";
import { ResponseVehicle } from "../types/api";
import { Language } from "../types/language";

export const fetchVehicles = async (
  baseUrl: string,
  lang: Language = "en",
  acodes: string[],
  province: Province
) => {

  const headers: RequestInit['headers'] = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Content-Language': lang
  };

  const url = `${baseUrl}/vehicles?acode=${acodes.join(',')}&province=${province}`;

  const response = await fetch(url, { headers });

  if (!response.ok) {
    throw new Error("Failed to fetch vehicles");
  }

  return await response.json() as { data: ResponseVehicle[]};
};
